<template>
  <div v-if="htmlContent" v-html="htmlContent"></div>
  <p v-else>
    <slot />
  </p>
</template>

<script setup lang="ts">
defineProps({
  htmlContent: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
@reference "~/assets/css/main.css";

p,
div {
  @apply pt-4 text-sm lg:text-lg lg:leading-[30px] text-grey-light lg:w-1/2;
}
</style>
